(function() {
    'use strict';

    angular
        .module('TR')
        .controller('SelectedHotel', SelectedHotel);

        function SelectedHotel(hotelFromSession, arrayUtil, imageService, $q, tripService, $routeParams, basketStore, $route, basketService, flightSearch, occupancyService, taxationService, mandatoryTransferService) {
        const sh = this;
        const w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
        const h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;
        sh.getTotalPrice = getTotalPrice;
        sh.nonInfants = occupancyService.getNumberOfNonInfantPassengers();
        sh.totalPrice = '';
        sh.bookingMiles = 0;
        sh.personMiles = personMiles;
        sh.flightMiles = flightMiles;
        sh.changeWorkflowState = changeWorkflowState;
        sh.openImageGallery = openImageGallery;
        sh.hotelImageIndex = 0;
        sh.showHotelImages = false;
        sh.isPackagePrice = TRPCONFIG.Domain.PackagePrice && $route.current && $route.current.area === 'holidays';
        sh.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
        sh.showStrikethroughPrice = TRPCONFIG.Domain.EnableStrikethroughPrices || false;
        tripService.usePackageRates().then(packagePrice => sh.isPackagePrice = packagePrice);

        sh.showCancellationsPopUp = false;
        sh.findCancellationData = function() {
            let intvl = setInterval(function() {
                if (TRPCONFIG.Domain.BrandedFareCancellations || sessionStorage.getItem('BrandedFareCancellations') !== null) {
                    clearInterval(intvl);
                    sh.showCancellationsPopUp = true;
                }
            }, 200);
        };

        sh.getFlightInfo = function() {
            return flightSearch.getFlightInfo();
        };

        sh.showFlightDetails = function(flight) {
            return flightSearch.showFlightDetailsModal(sh.isHotelFirstJourney, flight);
        };

        sh.showCancellationsDetails = function() {
            return flightSearch.showCancellationsDetailsModal();
        };

        sh.getRoomOccupancyDetails = function() {
            return occupancyService.getRoomOccupancyString().replace('(', 'for ').replace(')', '');
        };

        let isSkywards = document.querySelector('body').getAttribute('data-skywards');
        function changeWorkflowState(breadcrumb) {
            basketService.changeJourneyUrl(breadcrumb);
        }

        function openImageGallery() {
            sh.showHotelImages = true;
        }

        function getTotalPrice(price) {
            sh.totalPrice = Number(price);
        }

        function personMiles() {
            let skywardsMiles = sessionStorage.getItem('SkywardsMiles');
            let miles = 0;
            if (TRPCONFIG.Domain.SkywardsInfo && TRPCONFIG.Domain.SkywardsInfo[0] && TRPCONFIG.Domain.SkywardsInfo[0].Miles) {
                miles = TRPCONFIG.Domain.SkywardsInfo[0].Miles;
                sessionStorage.setItem('SkywardsMiles', miles);
            } else if (TRPCONFIG.Domain.FlightMiles && TRPCONFIG.Domain.FlightMiles[0]) {
                miles = TRPCONFIG.Domain.FlightMiles[0];
            } else {
                miles = skywardsMiles;
            }
            return miles;
        }

        function flightMiles() {
            return sessionStorage.getItem('SkywardsMilesFlights');
        }

        tripService.getTrip($routeParams.tripId).then(function(trip) {
            if (trip && trip.BasketId) {
                taxationService.getCityTax(trip.TripId, trip.BasketId).then(tax => {
                    sh.tax = tax;
                });
                $q.all([basketStore.hotel(trip.BasketId),
                        basketStore.hotelCost(trip.BasketId),
                        basketStore.hotelDeposit(trip.BasketId, $routeParams.productId)]).then(function(results) {
                    const hotelFromBasket = results[0];
                    if (hotelFromBasket) {
                        sh.hotelCost = results[1];
                        sh.hotelDeposit = results[2];
                        sh.hotelImages = arrayUtil.map(arrayUtil.numberArray(0, hotelFromBasket.Details.NumberOfPhotos - 1), function(i) {
                            return {
                                src: imageService.getImageUrl(hotelFromBasket.Details.Id, w, h, i, false)
                            };
                        });
                        if (sh.showStrikethroughPrice) {
                            const discounts = hotelFromBasket.CostBreakdown.length > 0 ? hotelFromBasket.CostBreakdown.filter(item => { return (!item.IsPriceHidden && item.UnitAmount < 0 && item.TypeId === 20); }) : null;
                            sh.totalPromotionAmount = discounts && discounts.length > 0 ? Math.abs(discounts.reduce((sum, item) => sum + item.UnitAmount, 0)) : null;
                        }
                        sh.mandatoryTransfersCost = mandatoryTransferService.getBookedTransfersPrice(hotelFromBasket.CostBreakdown);
                        hotelFromSession.getHotel(trip.HotelsRequest.AvailabilitySearchId, hotelFromBasket.Details.Id, $routeParams.tripId).then(function(hotel) {
                            sh.hotel = angular.extend(hotel, hotelFromBasket);
                            const hotelData = JSON.parse(sessionStorage.getItem('hotelData') || '{}');
                            if (!hotelData.Country) {
                                basketService.getFlight(trip.BasketId)
                                    .then(flight => {
                                        if (flight && flight.Details) {
                                            sessionStorage.setItem('selectedFlight', JSON.stringify(flight.Details.Itinerary));
                                            flightSearch.getDestinationAirports(flight.Details.Itinerary.Legs[0].ArrivalAirport.Code).then(result => {
                                                sessionStorage.setItem('destinationAirports', JSON.stringify(result.data));
                                            });
                                            flightSearch.getDestinationAirports(flight.Details.Itinerary.Legs[0].DepartureAirport.Code).then(result => {
                                                sessionStorage.setItem('originAirports', JSON.stringify(result.data));
                                            });
                                        }
                                    });
                                sessionStorage.setItem('selectedHotel', JSON.stringify(sh.hotel.Details.Itinerary));
                            }
                            if (sh.hotel && sh.hotel.IsCityTaxIncludedInPrice) {
                                sh.cityTax = {};
                                if (sh.hotel.DirectPayments && sh.hotel.DirectPayments.length > 0) {
                                    sh.cityTax.TotalAmount = sh.hotel.DirectPayments[0].Amount;
                                    sh.cityTax.CityTaxLocalAmount = Math.ceil(sh.hotel.DirectPayments[0].LocalAmount);
                                    sh.cityTax.CurrencyCode = sh.hotel.DirectPayments[0].LocalCurrency;
                                }
                            }
                            if (sh.hotel.Details.BookedItems) {
                                for (let i = 0; i < sh.hotel.Details.BookedItems.length; i++) {
                                    let title = sh.hotel.Details.BookedItems[i].Title;
                                    title = title.includes('(') && title.includes(')') ? title.slice(title.lastIndexOf('('), title.lastIndexOf(')') + 1) : null;
                                    let roomType = sh.hotel.Details.BookedItems[i].RoomDescription;
                                    roomType = roomType.replace(/\w+/g, function(w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
                                    let boardType = sh.hotel.Details.BookedItems[i].BoardDescription;
                                    sh.hotel.Details.BookedItems[i].Summary = `${roomType}, ${boardType} ${title}`;
                                }
                                sh.roomCount = sh.hotel.Details.BookedItems.length;
                                if (sh.roomCount > 1) {
                                    sh.roomAndBoardsData = [];
                                    for (let i = 0; i < sh.roomCount; i++) {
                                        sh.roomAndBoardsData.push(`${sh.hotel.Details.BookedItems[i].Summary}`);
                                    }
                                } else {
                                    let title = sh.hotel.Details.BookedItems[0].Title;
                                    title = title.includes('(') && title.includes(')') ? title.slice(title.lastIndexOf('('), title.lastIndexOf(')') + 1) : null;
                                    sh.occupancy = title.replace('(', '').replace(')', '');
                                    sh.adultCount = sh.hotel.Details.BookedItems[0].Adults;
                                    sh.childrenCount = sh.hotel.Details.BookedItems[0].ChildAges.length;
                                }
                            }
                            if (isSkywards) {
                                let tPrice = TRPCONFIG.Domain.TransferPrice;
                                if (tPrice === undefined) {
                                    tPrice = 0;
                                }
                            }
                        });
                    }
                });
            }
        });
    }
})();
